module.exports = __webpack_public_path__ + "img/album.65f07ac7.jpg";